/**
 * This file will be the base component. For now, it is just React.PureComponent
 */
import { PureComponent } from 'react';

export default PureComponent;
